<template>
  <div>
    <div class="video-wrapper">
      <!-- // :src="videoData.video_url" -->
      <iframe :id="videoData.id" :src="videoUrl" width="100%" height="360"
        frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
  name: 'VideoPlayer',
  props: ['videoData'],
  data() {
    return {
      getCurrentTimeRecord: null,
    };
  },
  methods: {
    getCurrentTime() {
      // 從上一次退出的地方播放
      const vm = this;
      const iframe = document.querySelector('iframe');
      const player = new Player(iframe);
      player.getCurrentTime().then((seconds) => {
        const nowData = {
          id: vm.videoData.id,
          current_time: seconds,
        };
        const localData = JSON.parse(window.localStorage.getItem('biz_thinking_video')) || [];
        const dataIndex = localData.findIndex((element) => element.id == vm.videoData.id);
        if (dataIndex > -1) {
          localData[dataIndex] = nowData;
        } else {
          localData.push(nowData);
        }
        window.localStorage.setItem('biz_thinking_video', JSON.stringify(localData));
      }).catch((error) => {
      });
    },
  },
  computed: {
    videoUrl() {
      if (this.videoData.hasOwnProperty('video_url')) {
        const pathVar = new URL(this.videoData.video_url).pathname.split('/')[1];
        return `https://player.vimeo.com/video/${pathVar}`;
      }
      return '';
    },
  },
  watch: {
  },
  mounted() {
    const iframe = document.querySelector('iframe');
    const player = new Player(iframe);
    const vm = this;
    // 從上一次退出的地方播放
    const localData = JSON.parse(window.localStorage.getItem('biz_thinking_video')) || [];
    if (localData.length > 0) {
      const second = localData.filter((data) => data.id == vm.videoData.id);
      if (second.length > 0) {
        player.setCurrentTime(second[0].current_time);
      }
    }
    player.on('play', (data) => {
      if (data.hasOwnProperty('seconds')) {
        vm.gaTrackEvent('Video', 'Play', vm.videoData.name);
      }
      window.clearInterval(vm.getCurrentTimeRecord);
      vm.getCurrentTimeRecord = window.setInterval(vm.getCurrentTime, 5000);
    });
    player.on('pause', (data) => {
      if (data.duration !== data.seconds) {
        vm.gaTrackEvent('Video', 'Pause', vm.videoData.name);
      } else {
        vm.gaTrackEvent('Video', 'Complete', vm.videoData.name);
      }
      window.clearInterval(vm.getCurrentTimeRecord);
    });
    player.on('qualitychange', () => {
      vm.gaTrackEvent('Video', 'Adjust Quality', vm.videoData.name);
    });
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.video-wrapper {
    position: relative;
    padding-bottom: 56.25%;  //16:9
    overflow: hidden;
}
.video-wrapper iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
